import { Component, inject, OnInit, resource } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UsersService } from '../../../services/users/users.service';
import { RequirementsService, getMissingFields } from '../../../services/requirements/requirements.service';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, map} from 'rxjs';


import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AvatarComponent } from '../../../components/avatar/avatar.component';
import { ProfileFieldsComponent } from './profile-fields/profile-fields.component';
import { UserStore } from '../../../stores/users.store';
import { toSignal } from '@angular/core/rxjs-interop';
import { RequiredField } from '../../../services/requirements/requirements.model';
import { AlertComponent } from "../../../components/alert/alert.component";



@Component({
  selector: 'app-edit-profile',
  imports: [MatMenuModule, MatButtonModule, MatTooltipModule, MatFormFieldModule, MatInputModule, FormsModule, FaIconComponent, AvatarComponent, ProfileFieldsComponent, AlertComponent],
  templateUrl: './edit-profile.component.html',
  styleUrl: './edit-profile.component.css'
})
export class EditProfileComponent {

  readonly $users = inject(UsersService) ;
  readonly $requirements = inject(RequirementsService) ;
  readonly $route = inject(ActivatedRoute) ;
  readonly $router = inject(Router) ;
  readonly userStore = inject(UserStore) ;

  user = this.userStore.user ;
  loading = this.userStore.loading ;

  returnUrl = toSignal(
    this.$route.queryParams.pipe(map(params => params['returnUrl']))
  );

  requirements = resource({
    params: () => ({returnUrl: this.returnUrl()}),
    loader: ({params}) => firstValueFrom(this.$requirements.getRequirementsFromReturnUrl(params.returnUrl)),
  });

  async save() {

    await firstValueFrom(this.$users.updateUser(this.user()!)) ;
    this.userStore.refreshUser();

    if (this.returnUrl())
      this.$router.navigateByUrl(this.returnUrl()!);
    else 
      this.$router.navigate(['/']) ;
  }

  takeSelfie() {

    let returnUrl = '/edit-profile';
    if (this.returnUrl())
      returnUrl = returnUrl + "?returnUrl=" + this.returnUrl() ;

    this.$router.navigate(["/take-selfie"], {queryParams: {returnUrl}}) ;

  }

  async deleteSelfie() {
    this.user()!.profileImage = undefined ;

    await firstValueFrom(this.$users.updateUser(this.user()!)) ;
    this.userStore.refreshUser() ;
    
  }


  get missingFields(): RequiredField[] {
    if (!this.user() || !this.requirements.value()) {
      return [] ;
    }

    return getMissingFields(this.user()!, this.requirements.value()!) ;
  }


}
